@if (insightContainer?.percentages) {
  @if (insightContainer.current.telemetryCount > 0) {
    <article>
      <div class="weekly-changes">
        <h4>Weekly changes</h4>
        <section>
          <table class="table">
            <thead>
              <tr>
                @for (p of insightContainer.percentages[forCollection]; track $index) {
                  <th [title]="p.annotation">
                    {{ p.d | amDateFormat: 'DD' }}
                  </th>
                }
              </tr>
              <tr>
                @for (p of insightContainer.percentages[forCollection]; track $index) {
                  <th [title]="p.annotation">
                    {{ p.d | amDateFormat: 'dd' }}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                @for (p of insightContainer.percentages[forCollection]; track $index) {
                  <td [title]="p.annotation">{{ p.v | number: '1.0-0' }}%</td>
                }
              </tr>
              <tr>
                @for (p of insightContainer.percentages[forCollection]; track $index) {
                  <td [title]="p.annotation" class="arrows">
                    <span class="mdi" [class.mdi-arrow-down-bold-outline]="p.v < 0" [class.mdi-arrow-up-bold-outline]="p.v > 0" [class.green]="p.v > 0" [class.red]="p.v < 0"></span>
                  </td>
                }
              </tr>
            </tbody>
          </table>
        </section>
      </div>
      <section>
        <app-d3-bar
          [legendHasMultipleRows]="true"
          [telemetry]="insightContainer.percentagesFullMonth[forCollection]"
          [min]="-100"
          [max]="100"
          [dateFrom]="insightContainer.current.configuration.start"
          [dateTo]="insightContainer.current.configuration.end"
          [ranges]="insightContainer.current.configuration.ranges"
          [colours]="[
            { from: -101, to: 0, colour: 'red' },
            { from: 0, to: 101, colour: 'green' }
          ]">
        </app-d3-bar>
      </section>
    </article>
  } @else {
    <app-info-panel>No data</app-info-panel>
  }
}
